// extracted by mini-css-extract-plugin
module.exports = {"tabContentContainer":"UserSettingsHeader__tabContentContainer","blockWrapper":"UserSettingsHeader__blockWrapper","tabContainer":"UserSettingsHeader__tabContainer"};